module.exports = __webpack_public_path__ + "944ea2d8ea11ab203508682e264f6af8.webp";